module.exports = __webpack_public_path__ + "img/clover.6d80ee85.svg";